<template>
  <v-container class="pt-6">
    <v-row>
      <v-col cols="12" v-if="gruposValidos.length">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text>
            <div class="mb-0 font-weight-bold text-h5 textPrimary--text text-center">
              Mis grupos
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <SinGrupos v-if="!gruposValidos.length && !encuestaSatis.visible" />

      <!-- Encuesta bloqueante: arriba, antes de grupos -->
      <v-col
        v-if="encuestaSatis.visible"
        cols="12"
      >
        <EncuestaSatisfaccion
          :encuestaSatis="encuestaSatis"
          @contestada="onEncuestaSatisContestada"
        />
      </v-col>

      <GruoisListAlumnos v-if="gruposValidos.length && !encuestaSatis.visible"/>

      <v-col cols="12">
        <!-- Avisos -->
        <v-row align="stretch">

          <v-col
            v-if="sesionReferral.ok"
            cols="12"
            sm="6"
            md="6"
            lg="4"
            class="d-flex"
          >
            <ComparteGana/>
          </v-col>

          <!-- CURSO DE INDUCCIÓN -->
          <v-col cols="12" sm="6" md="6" lg="4" class="d-flex" v-if="verCursoInduccion">
            <v-card class="shadowCard flex-grow-1" :to="{name: 'CursoInduccion'}">
              <v-img src="@/assets/backgrounds/induccion_adultos_fast.png"/>
            </v-card>
          </v-col>

          <!-- Curso de descuento -->
          <v-col cols="12" sm="6" md="6" lg="4" v-if="avisoDescuento.visible">
            <AvisoPago v-if="avisoDescuento.visible" :avisoDescuento="avisoDescuento" />
          </v-col>

          <!-- Calificar clase -->
          <v-col cols="12" sm="6" md="6" lg="4" v-if="encuesta.visible">
            <Encuesta v-if="encuesta.visible" :encuesta="encuesta"/>
          </v-col>

          <!-- Beca siguiente nivel -->
          <v-col cols="12" sm="6" md="6" lg="4" v-if="becaNivel.visible">
            <BecaNivel v-if="becaNivel.visible" :becaNivel="becaNivel"/>
          </v-col>

          <!-- Calificar clase -->
          <v-col cols="12" sm="6" md="6" lg="4" v-if="encuestaPresencial.visible">
            <EncuestaPresencial v-if="encuestaPresencial.visible" :encuestaPresencial="encuestaPresencial"/>
          </v-col>

          <!-- Subir Video de 14vo nivel -->
          <v-col cols="12" sm="6" md="6" lg="4" v-if="subirVideo.visible">
            <CargarVideo v-if="subirVideo.visible" :subirVideo="subirVideo"/>
          </v-col>

          <!-- Curso del exciiiii -->
          <v-col cols="12" sm="6" md="6" lg="4" class="d-flex" v-if="accesoExci">
            <v-card class="shadowCard flex-grow-1" :to="{name: 'MaterialExci'}">
              <v-img src="https://fastenglish.com.mx/public/images/infoexci.jpg"/>
            </v-card>
          </v-col>

        </v-row>
      </v-col>
    </v-row>

    <v-speed-dial
      right
      fixed
      style="bottom: 15%;"
    >
      <template v-slot:activator>
        <v-btn
          color="blue darken-2"
          dark
          fab
          @click="refrescarEncuestaYGrupos(), getCursoExci(), getEncuesta(), getEncuestaPresencial()"
        >
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <!-- Alertas -->
    <Alerta         v-if="respuestaAlerta"         :parametros="parametros"/>
    <Loader         v-if="cargar"                  :loader="loader"/>
    <SinAcceso      v-if="alertaAcceso.estatus"    :alertaAcceso="alertaAcceso" @click="salirLogin()"/>

  </v-container>
</template>
<script>
  // Importar lebrerías
  import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');
  import { Clipboard } from '@capacitor/clipboard';
  import { esBloqueoCiclo, dispararBloqueoCiclo } from '@/utils/bloqueoCiclo'
  import { sesionReferralDesdeGetters } from '@/referrals/sesion'
  // import { Share } from '@capacitor/share';

  // Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'
  import SinAcceso     from '@/components/alertas/SinAcceso.vue'

  import SinGrupos           from '@/components/grupos/SinGrupos.vue'
  import Encuesta            from '@/components/grupos/Encuesta.vue'
  import GruoisListAlumnos   from '@/components/grupos/GruoisListAlumnos.vue'

  // Avisos
  import AvisoPago            from '@/components/avisos/AvisoPago.vue'
  import ComparteGana         from '@/components/avisos/ComparteGana.vue'
  import EncuestaPresencial   from '@/components/avisos/EncuestaPresencial.vue'
  import BecaNivel            from '@/components/avisos/BecaNivel.vue'
  import CargarVideo          from '@/components/avisos/CargarVideo.vue'
  import EncuestaSatisfaccion from '@/components/avisos/EncuestaSatisfaccion.vue'


  export default {
    components:{
      Alerta,
      Loader,
      SinGrupos,
      Encuesta,
      SinAcceso,
      GruoisListAlumnos,
      AvisoPago,
      ComparteGana,
      EncuestaPresencial,
      BecaNivel,
      CargarVideo,
      EncuestaSatisfaccion
    },

    data () {
      return {
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },

        alertaAcceso:{
          estatus: false,
        },

        encuesta:{
          visible: false
        },

        encuestaSatis:{
          visible: false,
          sinGrupo: false
        },

        dialogComparteGana: false,

        respuestaAlerta:false,
        loader: true,
        cargar: false,

        avisoDescuento:{
          visible: false,
        },

        encuestaPresencial:{
          visible: false,
        },

        becaNivel:{
          visible: false,
        },

        subirVideo:{
          visible: false,
          id_grupo: 0,
        },

        visibleEncuesta: false,
        accesoExci:false,
        verCursoInduccion: false,
        tipoCurso: 0
      }
    },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela', 'getLogeadoLMS', 'getDatosUsuarioLMS' ]),

      gruposValidos () {
        return Array.isArray(this.getGrupos) ? this.getGrupos : []
      },

      sesionReferral () {
        return sesionReferralDesdeGetters({
          logeado: this.getLogeadoLMS,
          usuario: this.getUsuarioLMS,
          datosUsuario: this.getDatosUsuarioLMS,
          escuela: this.getEscuela,
        })
      },
    },

    async created ( ){
      await this.refrescarEncuestaYGrupos()
      await this.getAcceso( )
      await this.getCursoExci( )
      await this.getcursoInduccion()
      await this.getSubirVideo()
      await this.getAnuncioDescuento()
      // await this.getEncuesta()
      // await this.getEncuestaPresencial()
      await this.getBecaNivel()
    },

    methods:{
      ...mapActions( 'login', [ 'abrirGrupo', 'grabarGruposUsuario', 'salirLogin' ]),

      async refrescarEncuestaYGrupos () {
        if (!this.getUsuarioLMS || this.getUsuarioLMS.id == null) return
        await this.getEncuestaSatisfaccion()
        if (!this.encuestaSatis.visible) {
          await this.actualizarGrupos()
        }
      },

      onEncuestaSatisContestada () {
        this.encuestaSatis.visible = false
        this.actualizarGrupos()
      },

      getAcceso ( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('usuario.acceso/' + id_usuario).then( response => {
          // Guardamos los grupos
        }).catch( error =>{
          this.alertaAcceso.estatus = true
        }).finally(()=>{ this.cargar = false })
      },

      getSubirVideo( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('grabar.video/' + id_usuario).then( response => {
          this.subirVideo.visible = true
          this.subirVideo.id_grupo = response.body.id_grupo
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getCursoExci( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.iderp )
        // Hacemos la petición
        this.$http.get('exci.activar.usuario/' + id_usuario).then( response => {
          this.accesoExci = true
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getcursoInduccion( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.iderp )
        // Hacemos la petición
        this.$http.get('induccion.activar/' + id_usuario).then( response => {
          this.tipoCurso =  response.body.registradoInduccion.tipo
          console.log( this.tipoCurso )
          this.verCursoInduccion = true
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getEncuestaPresencial( ){
        const id_usuario_erp = base64.encode( this.getUsuarioLMS.iderp )
        const id_usuario     = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('encuestas.presencial/' + id_usuario).then( response => {
          this.encuestaPresencial.visible = true
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getBecaNivel( ){
        const id_usuario_erp = base64.encode( this.getUsuarioLMS.iderp )
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('encuestas.becanivel/' + id_usuario + '/' + id_usuario_erp).then( response => {
          this.becaNivel.visible = true
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getEncuesta ( ) {
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('aviso.evaluacion/' + id_usuario).then( response => {
          this.encuesta.visible = true
          // Guardamos los grupos
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getEncuestaSatisfaccion ( ) {
        if (!this.getUsuarioLMS || this.getUsuarioLMS.id == null) {
          return Promise.resolve()
        }
        this.encuestaSatis = {
          visible: false,
          sinGrupo: false
        }
        // id LMS + iderp; backend detecta ciclo vigente, ventana Excel (vie–dom) y encuesta previa.
        return this.$http.post('encuestas.satisfaccion.habil', {
          id: this.getUsuarioLMS.id,
          iderp: this.getUsuarioLMS.iderp
        }).then( response => {
          const b = response.body || {}
          const encuestaPendiente = b.encuestaPendiente !== false
          const enVentana = b.enVentana !== false
          const mostrarEncuesta = encuestaPendiente && enVentana
          this.encuestaSatis = {
            visible: mostrarEncuesta,
            sinGrupo: !!b.sinGrupo,
            encuestaPendiente,
            enVentana,
            cicloNombre: b.cicloNombre,
            fechaInicioCiclo: b.fechaInicioCiclo,
            fechaFinCiclo: b.fechaFinCiclo,
            encuestaViernes: b.encuestaViernes,
            encuestaDomingo: b.encuestaDomingo,
            encuestaLunes: b.encuestaLunes || b.encuestaViernes,
            grupos: Array.isArray(b.grupos) ? b.grupos : []
          }
          if (mostrarEncuesta) {
            this.grabarGruposUsuario([])
          }
        }).catch(() =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      actualizarGrupos ( ) {
        if (!this.getUsuarioLMS || this.getUsuarioLMS.id == null) {
          return Promise.resolve()
        }
        this.cargar = true
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        return this.$http.get('grupos.alumno/' + id_usuario).then( response => {
          const grupos = response.body || []
          if (Array.isArray(grupos)) {
            this.grabarGruposUsuario( grupos )
          }
        }).catch( error =>{
          const code = error && error.body && error.body.code
          if (code === 'ENCUESTA_SATIS_PENDIENTE') {
            this.grabarGruposUsuario( [] )
            return
          }
          if (esBloqueoCiclo(error)) {
            dispararBloqueoCiclo(error)
            return
          }
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      validarError ( value ) {
        this.cargar = false
        if (esBloqueoCiclo(value)) {
          dispararBloqueoCiclo(value)
          return
        }
        const status = value && value.status
        if (status == 400 || status == 500) {
          this.parametros.mensaje = (value.body && value.body.message) || 'No se pudo completar la petición'
          this.parametros.dialogError = true
          this.parametros.color = '#FF2C2C'
          this.respuestaAlerta = true
        }
      },

      getAnuncioDescuento( ) {
        return this.$http.get('usuario.anuncio.descuento').then( response => {
          this.avisoDescuento['aviso'] = response.body
          this.avisoDescuento.visible = true
        }).catch( error =>{
          // this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

    }
  }
</script>

<style scoped>

  /* STYLE FOR AVISO PAGO  */
  .responsive-banner {
    min-width: 230px;
    position: relative;
    height: auto;
    border-radius: 10px;
    overflow: hidden;
    background-image: linear-gradient(to bottom right, #5BC2D4, #84D9E0);
    background-repeat: no-repeat;
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
  }

  .container-envelope {
    padding: 35px 15px;
    color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .col-xs-12 {
    text-align: center;
  }

  img {
    width: 100%;
    position: relative;
  }

  span:after,
  span:before {
    content: "";
    position: absolute;
    display: block;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.1);
    width: 50px;
    height: 50px;
  }

  .circle-a:before {
    width: 500px;
    height: 500px;
    top: -300px; left: 52%;
    -webkit-transform: translate(-50%,0);
    -ms-transform: translate(-50%,0);
    transform: translate(-50%,0);
  }

  .circle-a:after {
    top: 160px;
    right: 10%;
  }

  .circle-b:before {
    top: 60%;
    left: -25px;
  }

  .circle-b:after {
    width: 150px;
    height: 150px;
    bottom: -70px;
    right: -70px;
  }

  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }

  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }

</style>
